import {DataObjectId} from './data-object'
import {Util} from 'yougile-util'
/**
 * Represents full global data object identifier, consisting of company id and
 * object id in the form of 'companyId/objectId'
 * This type can be used as a key for maps.
 */

export type DataAddr = string & {__type: 'DataAddr'}
interface DataAddrObject {
  companyId: DataObjectId
  objectId: DataObjectId
}

export class DataObjectAddress {
  public static create(
    companyId: DataObjectId,
    objectId: DataObjectId
  ): DataAddr {
    return (companyId + '/' + objectId) as unknown as DataAddr
  }

  public static isAddr(addr: DataAddr): boolean {
    if (!addr || typeof addr !== 'string') {
      return false
    }
    const parts = addr.split('/')
    return (
      parts.length === 2 &&
      Util.isIdOrUUID(parts[0]) &&
      Util.isIdOrUUID(parts[1])
    )
  }

  public static parse(addr: DataAddr): DataAddrObject {
    const parts = addr.split('/')
    return {
      companyId: parts[0] as DataObjectId,
      objectId: parts[1] as DataObjectId
    }
  }
}
